import axios, { AxiosResponse } from "axios";
import router from '@/router/router'
import { isProtected } from "@/router/router";
import {useAuthStore} from "@/stores/auth";

axios.interceptors.response.use(
    (response: AxiosResponse) => response,
    (error) => {
        if(error.response?.status === 401){
            const currentPath = router.currentRoute.value.path
            if(isProtected(currentPath)){
                useAuthStore().isAuthenticated = false
                router.replace("/admin")
            }
        }
        return Promise.reject(error)
    }
)
